<template lang="pug">
  .call-button
    ModalReveal.p-0.m-0
      slot(slot="trigger")
        .pr-2(style="color: blue; cursor: pointer;").fa.fa-phone.fa-lg
      .row
        .column
          label Number to call:
            input(type="text", v-model="payload.external")
      .row
        .column
          label Intern to use:
            input(type="text", v-model="payload.internal")
      .row
        .column
          button.button.action-button(@click="requestCall", :class="{disabled: loading}") Request call
      .row
        .column
          span(v-if="loading").fa.fa-spinner.fa-spin
      .row
        .column
          p {{ result }}
</template>
<script type="text/babel">
import ModalReveal from "../structure/foundation/ModalReveal";
import KeplerBackofficeSdk from "src/lib/kepler/backoffice";

export default {
  name: 'CallButton',
  components: {
    ModalReveal
  },
  data() {
    return {
      loading: false,
      result: "",
      payload: {
        internal: "",
        external: ""
      }
    }
  },
  mounted() {
    this.payload.external = this.phone
    let i = localStorage.getItem("c2c-internal")

    if (i) {
      this.payload.internal = i
    }
  },
  methods: {
    requestCall() {
      localStorage.setItem("c2c-internal", this.payload.internal)
      this.loading = true
      this.result = ""
      KeplerBackofficeSdk.calls.request(this.payload, () => {
        this.loading = false
        this.result = "CALL REQUESTED"
      }, () => {
        this.loading = false
        this.result = "CALL REQUEST FAIL"
      })
    }
  },
  computed: {},
  props: {
    phone: {
      required: true
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CallButton.vue?4df80560